import React from 'react';
import { useSelector } from 'react-redux';
import whiteList from "../../config/whitelistAttributes.json";
import { Link } from 'react-router-dom';
import { FiExternalLink } from 'react-icons/fi';
const ChatWrapup = () => {
    const chatSliceData = useSelector((state: any) => { return state.chatSlice });
    return (
        <div className="card wrapup-box collapse show mt-3" id="ChatWrapup">
            <div className="card-header d-flex justify-content-between align-items-center">
                <h6 className='m-0'>Customer Data</h6>
            </div>
            <div className="card-body height-400">
                <ul className='list-unstyled'>
                    {Object.keys(chatSliceData.selectedInfo).map((key) => (
                        (whiteList.attributes?.includes(key) ? (
                            (key === "interaction_link") ? (
                                <li>
                                    <a target="_blank" style={{ color: 'blue' }} href={chatSliceData.selectedInfo["interaction_link"]["value"]}>
                                        <strong>IMS Record:</strong> {chatSliceData.selectedInfo["interaction_number"]["value"]}
                                    </a>
                                </li>
                            ) : (key !== "Language") ? (
                                <li>
                                    <strong>{key + ":"}</strong>&nbsp;<span>{chatSliceData.selectedInfo[key]["value"]}</span>
                                </li>
                            ) : null
                        ) : (
                            <></>
                        ))

                    ))}{
                        chatSliceData.selectedInfo?.Language && (
                            <li>
                                <strong>{"Language:"}</strong>&nbsp;<span>{chatSliceData.selectedInfo?.Language?.value}</span>
                            </li>
                        )

                    }

                    {chatSliceData.isTranslationDisabledByAgent ? (
                        <li>
                            <br></br>
                            <strong>Warning:</strong> <span>Please note you have previously disabled message translation for this chat. If you wish to enable it back, please click on the button right next to the chat.</span>
                        </li>
                    ) : (
                        <></>
                    )}
                </ul>
            </div>
        </div>

    )
}
export default ChatWrapup;